export default __webpack_public_path__ + "static/media/yt.502e7069.svg";